import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-345.529 249.854 53.65 65.801",
  "enable-background": "new -345.529 249.854 53.65 65.801",
  "aria-hidden": "true",
  focusable: "false"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M-316.558 293.113v-6.733c0-.77-.96-1.395-2.146-1.395s-2.145.625-2.145 1.395v6.733c-2.055.845-3.504 2.866-3.504 5.227 0 3.12 2.53 5.652 5.65 5.652s5.652-2.53 5.652-5.652c0-2.36-1.45-4.38-3.506-5.227z" }, null, -1),
    _createElementVNode("path", { d: "M-299.538 315.655h-38.33c-4.224 0-7.66-3.39-7.66-7.556v-27.22c0-4.167 3.436-7.556 7.66-7.556h38.33c4.224 0 7.66 3.39 7.66 7.556v27.22c0 4.165-3.436 7.555-7.66 7.555zm-38.33-38.134c-1.91 0-3.464 1.508-3.464 3.36v27.22c0 1.852 1.554 3.358 3.463 3.358h38.332c1.908 0 3.462-1.507 3.462-3.36V280.88c0-1.852-1.554-3.36-3.462-3.36h-38.33z" }, null, -1),
    _createElementVNode("path", { d: "M-332.296 275.423v-10.88c0-4.757 4.87-9.626 9.627-9.626h7.93c4.756 0 9.628 4.87 9.628 9.627v10.88h5.062v-10.88c0-8.1-6.59-14.69-14.69-14.69h-7.928c-8.1 0-14.69 6.59-14.69 14.69v10.88h5.062z" }, null, -1)
  ]))]))
}
export default { render: render }